export default __webpack_public_path__ + "assets/models/7431831c2990b7d846e081edac0575bf.glb";